import * as React from 'react'

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import Input from '../Arcade/Input/Input'

const Wrapper = styled.span`
  position: relative;
  display: flex;
`

const CurrencyPrefix = styled.span<{ disabled?: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${props => props.theme.typography.input};
  padding: 0 1.375rem;
  height: 100%;

  ${props =>
    props.disabled &&
    css`
      color: ${props.theme.colors.disabledLabel};
    `}
`
export type CurrencyInputProps = {
  currencyPrefix?: string
  showCurrencyPrefix?: boolean
  wrapperRef?: React.Ref<HTMLSpanElement>
} & React.ComponentProps<typeof Input>

const CurrencyInput = ({
  currencyPrefix = '$',
  disabled,
  showCurrencyPrefix = true,
  wrapperRef,
  ...props
}: CurrencyInputProps) => (
  <Wrapper ref={wrapperRef}>
    {showCurrencyPrefix && (
      <CurrencyPrefix className="currency-prefix" disabled={disabled}>
        {currencyPrefix}
      </CurrencyPrefix>
    )}
    <PaddedTextInput disabled={disabled} showCurrencyPrefix={showCurrencyPrefix} {...props} />
  </Wrapper>
)

const PaddedTextInput = styled(Input)<{ showCurrencyPrefix: boolean }>`
  width: 100%;
  padding-left: ${props => props.showCurrencyPrefix && '3rem'};

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: ${({ theme }) => theme.spacing.empty};
  }

  appearance: textfield;
`

export default CurrencyInput
